import { translate } from '../../utils';
import { PortfolioAlert } from './PortfolioAlert';

/** @param {{ alerts: import('./portfolioDashboard.types').PortfolioAlert[] }} props */
export const PortfolioAlerts = function PortfolioAlerts({ alerts }) {
    return (
        <div className="box box-solid mb-0">
            <div className="box-header">
                <h3 className="box-title">
                    {translate('frontend', 'PORTFOLIO_DASHBOARD_ALERTS')}
                </h3>
            </div>

            <div className="box-body">
                {alerts.length === 0 ? (
                    <p className="my-5 text-center text-muted">{translate('frontend', 'PORTFOLIO_DASHBOARD_NO_ALERTS')}</p>
                ) : (
                    <div className="last-mb-0">
                        {alerts.map((alert) => (
                            <PortfolioAlert
                                key={alert.alertType}
                                alert={alert}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};
